import React, { ReactNode } from "react";


interface Props {
  label: ReactNode;
  checked: boolean;
  handleChange: (checked: boolean) => void;
  className?: string;
  id?: string;
  isDisabled?: boolean;
  labelClassName?: string;
}

export const Checkbox = (props: Props) => {
  const {
    label,
    checked,
    handleChange,
    className = "",
    id = className,
    isDisabled = false,
    labelClassName = "",
  } = props;

  return (
    <>
      <input
        type="checkbox"
        className={className}
        id={id}
        onChange={(event) => handleChange(event.target.checked)}
        checked={checked}
        disabled={isDisabled}
      />
      <label
        htmlFor={id}
        className={labelClassName}
      >
        {label}
      </label>
    </>
  );
};
